import axios from "../../services/axios";
const BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const fetchTotpCode = async ({ aController }) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/me/get_totp_code`,
      {
        access_token: localStorage.getItem("accessToken"),
      },
      {
        signal: aController.signal,
      },
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;

    return {
      error: {
        message: error.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};
export const sendVerifyTotpCode = async ({ aController, code }) => {
  try {
    const response = await axios.post(
      `${BASE_URL}/me/verify_totp_code`,
      {
        access_token: localStorage.getItem("accessToken"),
        code,
      },
      {
        signal: aController.signal,
      },
    );

    return response.data;
  } catch (error) {
    if (error.code === "ERR_CANCELED") return null;

    return {
      error: {
        message: error.response?.data?.details ?? "Oops! Something Went Wrong.",
        error: error,
        status: error?.response?.status ?? 504,
      },
    };
  }
};

// ------------------------------------------------------------- preferences
// Small per-user settings kept server-side so they follow the user across
// browsers and devices (e.g. the home dashboard's last applied filters).
// Both throw on failure so callers can fall back to local state.

export async function fetchUserPreferences({ signal } = {}) {
  const response = await axios.get(`${BASE_URL}/me/preferences`, { signal });
  return response.data ?? {};
}

export async function saveUserPreference({ key, value }) {
  const response = await axios.put(`${BASE_URL}/me/preferences`, {
    key,
    value,
  });
  return response.data;
}
